function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.4805 165.586C46.9737 138.32 110.464 185.191 176.502 158.696C229.349 137.504 218.791 95.4119 275.468 80.4568C282.829 78.5181 335.943 65.3614 381.344 95.3311C426.931 125.428 432.256 177.529 433.992 194.589C440.23 255.759 401.755 294.503 390.844 305.1C339.492 354.982 265.449 353.59 245.63 352.936C221.261 352.131 130.719 345.585 68.8807 280.388C37.6906 247.497 4.45983 189.836 24.4663 165.583L24.4805 165.586Z",
  fill: "url(#paint0_linear_19919_10815)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M93.013 109.987H321.376C330.045 109.987 337.084 117.025 337.084 125.695V297.19C337.084 305.86 330.045 312.899 321.376 312.899H93.013C84.3433 312.899 77.3047 305.86 77.3047 297.19V125.695C77.3047 117.025 84.3433 109.987 93.013 109.987Z",
  fill: "#E3F2FF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M337.095 125.695V130.142H77.3047V125.695C77.3047 117.014 84.3321 109.987 93.013 109.987H321.376C330.057 109.987 337.084 117.014 337.084 125.695H337.095Z",
  fill: "#4DA8F2"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M285.283 237.824H227.683C226.929 237.824 226.318 238.436 226.318 239.19V240.846C226.318 241.6 226.929 242.211 227.683 242.211H285.283C286.037 242.211 286.648 241.6 286.648 240.846V239.19C286.648 238.436 286.037 237.824 285.283 237.824Z",
  fill: "#B3DCFF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M227.683 253.745H285.273C286.028 253.745 286.638 254.355 286.638 255.11V256.757C286.638 257.512 286.028 258.132 285.263 258.132H227.673C226.918 258.132 226.308 257.522 226.308 256.766V255.12C226.308 254.365 226.918 253.755 227.673 253.755L227.683 253.745Z",
  fill: "#B3DCFF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M309.445 243.596L304.439 239.229C304.032 238.87 303.983 238.25 304.342 237.834C304.7 237.427 305.32 237.379 305.736 237.737L309.281 240.826L314.326 235.2C314.694 234.793 315.314 234.764 315.72 235.123C316.127 235.481 316.156 236.11 315.798 236.517L309.455 243.596H309.445Z",
  fill: "#4DA8F2"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M309.445 260.504L304.439 256.136C304.032 255.778 303.983 255.158 304.342 254.742C304.7 254.335 305.32 254.287 305.736 254.645L309.281 257.734L314.326 252.108C314.694 251.701 315.314 251.672 315.72 252.031C316.127 252.399 316.156 253.018 315.798 253.425L309.455 260.504H309.445Z",
  fill: "#4DA8F2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M227.683 270.662H285.273C286.028 270.662 286.638 271.272 286.638 272.028V273.674C286.638 274.429 286.028 275.039 285.273 275.039H227.683C226.928 275.039 226.318 274.429 226.318 273.674V272.028C226.318 271.272 226.928 270.662 227.683 270.662Z",
  fill: "#B3DCFF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M309.445 277.412L304.439 273.045C304.032 272.687 303.983 272.067 304.342 271.65C304.7 271.244 305.32 271.195 305.736 271.554L309.281 274.643L314.326 269.007C314.694 268.6 315.314 268.571 315.72 268.929C316.127 269.288 316.156 269.917 315.798 270.324L309.455 277.403L309.445 277.412Z",
  fill: "#4DA8F2"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.83
}, /*#__PURE__*/React.createElement("path", {
  d: "M66.9786 92H130.33C133.632 92 136.309 97.5091 136.309 104.305V180.06C136.309 186.856 133.632 192.365 130.33 192.365H66.9786C63.6766 192.365 60.9999 186.856 60.9999 180.06V104.305C60.9999 97.5091 63.6766 92 66.9786 92Z",
  fill: "#F6E8FE"
}));

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M90.0338 150.324C92.2885 151.09 94.7027 151.515 97.2126 151.547C104.817 151.643 111.623 148.091 115.952 142.507C118.951 138.636 120.77 133.797 120.834 128.522C120.834 128.001 120.834 127.479 120.802 126.958C120.674 124.619 120.206 122.364 119.44 120.258C116.229 111.399 107.795 105.028 97.8082 104.901C92.4267 104.826 87.4601 106.581 83.4718 109.591C77.9095 113.792 74.2723 120.418 74.1766 127.926C74.0489 138.296 80.696 147.176 90.0232 150.324H90.0338ZM80.026 128.001C80.1004 122.417 82.7805 117.472 86.907 114.324C89.9062 112.026 93.6711 110.686 97.7444 110.74C105.221 110.835 111.549 115.61 113.963 122.258C114.538 123.842 114.889 125.533 114.984 127.288C115.006 127.671 115.006 128.064 115.006 128.458C114.952 132.414 113.591 136.041 111.347 138.944C108.103 143.135 102.998 145.793 97.2977 145.73C95.4153 145.708 93.6073 145.379 91.9056 144.815C84.9182 142.454 79.9303 135.796 80.026 128.022V128.001Z",
  fill: "#EED0FD"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M111.347 138.934L115.963 142.507C111.635 148.091 104.828 151.643 97.2237 151.547C94.7138 151.515 92.2995 151.09 90.0449 150.324L91.9167 144.794C93.6077 145.368 95.4157 145.687 97.2981 145.708C102.999 145.783 108.104 143.113 111.347 138.934Z",
  fill: "#C070EA"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M119.452 120.259L113.964 122.258C114.687 124.268 115.027 126.374 115.006 128.458C114.953 132.415 113.592 136.041 111.348 138.945L115.963 142.518C118.962 138.647 120.781 133.808 120.845 128.533C120.877 125.672 120.409 122.896 119.452 120.269V120.259Z",
  fill: "#D49CF1"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M83.4931 109.591C87.4813 106.581 92.448 104.827 97.8295 104.901C107.805 105.029 116.239 111.41 119.462 120.258L113.974 122.258C111.56 115.611 105.242 110.825 97.7551 110.729C93.6817 110.676 89.9275 112.016 86.9177 114.313L83.4931 109.58V109.591Z",
  fill: "#DE9EFF"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M120.653 161.768H77.3884C76.0316 161.768 74.9316 162.868 74.9316 164.225V164.544C74.9316 165.9 76.0316 167 77.3884 167H120.653C122.01 167 123.11 165.9 123.11 164.544V164.225C123.11 162.868 122.01 161.768 120.653 161.768Z",
  fill: "#C070EA"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M120.653 173.562H77.3884C76.0316 173.562 74.9316 174.662 74.9316 176.019V176.338C74.9316 177.695 76.0316 178.795 77.3884 178.795H120.653C122.01 178.795 123.11 177.695 123.11 176.338V176.019C123.11 174.662 122.01 173.562 120.653 173.562Z",
  fill: "#C070EA"
});

var _ref18 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.78
}, /*#__PURE__*/React.createElement("path", {
  d: "M269.186 146.315H360.363C365.134 146.315 369 150.181 369 154.952V210.657C369 215.428 365.134 219.293 360.363 219.293H269.186C264.415 219.293 260.55 215.428 260.55 210.657V154.963C260.55 150.192 264.415 146.327 269.186 146.327V146.315Z",
  fill: "#4DA8F2"
}));

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M274.739 155.041H304.658C306.457 155.041 307.921 156.505 307.921 158.303V182.704C307.921 184.502 306.457 185.966 304.658 185.966H274.739C272.94 185.966 271.477 184.502 271.477 182.704V158.303C271.477 156.505 272.94 155.041 274.739 155.041Z",
  fill: "#E3F2FF"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M315.92 155.041H358.99C360.04 155.041 360.9 155.902 360.9 156.952V161.376C360.9 162.426 360.04 163.287 358.99 163.287H315.92C314.87 163.287 314.01 162.426 314.01 161.376V156.941C314.01 155.891 314.87 155.03 315.92 155.03V155.041Z",
  fill: "#E3F2FF"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M315.92 167.934H358.99C360.04 167.934 360.9 168.794 360.9 169.845V174.269C360.9 175.319 360.04 176.179 358.99 176.179H315.92C314.87 176.179 314.01 175.319 314.01 174.269V169.845C314.01 168.794 314.87 167.934 315.92 167.934Z",
  fill: "#E3F2FF"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M359.169 205.049H342.556C341.599 205.049 340.824 205.824 340.824 206.781V207.574C340.824 208.53 341.599 209.305 342.556 209.305H359.169C360.125 209.305 360.901 208.53 360.901 207.574V206.781C360.901 205.824 360.125 205.049 359.169 205.049Z",
  fill: "#E3F2FF"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M111.284 262.368H103.508V290.612H111.284V262.368Z",
  fill: "#78C2FF"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M122.344 259.519H114.568V290.612H122.344V259.519Z",
  fill: "#78C2FF"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M133.561 265.441H125.785V290.623H133.561V265.441Z",
  fill: "#78C2FF"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M144.768 253.765H136.992V290.612H144.768V253.765Z",
  fill: "#78C2FF"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M156.543 257.441H148.767V290.623H156.543V257.441Z",
  fill: "#78C2FF"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M168.464 262.368H160.688V290.612H168.464V262.368Z",
  fill: "#78C2FF"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M179.525 259.519H171.749V290.612H179.525V259.519Z",
  fill: "#78C2FF"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M190.741 265.441H182.965V290.623H190.741V265.441Z",
  fill: "#78C2FF"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M222.064 171.112H159.472C156.611 171.112 154.292 173.431 154.292 176.291V192.698C154.292 195.558 156.611 197.877 159.472 197.877H222.064C224.925 197.877 227.244 195.558 227.244 192.698V176.291C227.244 173.431 224.925 171.112 222.064 171.112Z",
  fill: "#EED0FD"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M176.04 184.599C176.04 184.466 176.04 184.342 176.04 184.208C176.04 184.16 176.04 184.122 176.04 184.075C176.002 183.292 175.84 182.548 175.582 181.842C174.514 178.895 171.7 176.768 168.371 176.72C166.578 176.701 164.918 177.283 163.592 178.285C161.741 179.687 160.53 181.89 160.492 184.399C160.444 187.852 162.667 190.809 165.776 191.868C166.53 192.125 167.331 192.268 168.17 192.278C169.124 192.287 170.031 192.135 170.879 191.829C172.291 191.324 173.512 190.427 174.418 189.264C175.296 188.128 175.878 186.736 176.011 185.219C176.03 185.019 176.04 184.809 176.04 184.599ZM162.438 184.418C162.457 182.558 163.353 180.908 164.727 179.858C165.729 179.095 166.978 178.647 168.342 178.666C170.832 178.695 172.94 180.288 173.751 182.501C173.941 183.035 174.056 183.588 174.094 184.179C174.094 184.313 174.104 184.437 174.094 184.571C174.094 185.133 173.999 185.677 173.836 186.192C173.627 186.879 173.302 187.508 172.873 188.062C172.72 188.262 172.549 188.453 172.368 188.634C171.299 189.693 169.821 190.341 168.19 190.322C167.76 190.322 167.341 190.265 166.94 190.17C166.759 190.132 166.568 190.074 166.396 190.017C164.069 189.225 162.409 187.012 162.438 184.418Z",
  fill: "#E3F2FF"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M123.179 206.396H185.772C188.634 206.396 190.952 208.713 190.952 211.575V227.982C190.952 230.843 188.634 233.161 185.772 233.161H123.179C120.318 233.161 118 230.843 118 227.982V211.575C118 208.713 120.318 206.396 123.179 206.396Z",
  fill: "#EED0FD"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M140.644 218.929C140.644 218.929 140.644 218.853 140.644 218.815C140.606 218.033 140.444 217.289 140.187 216.583C139.118 213.635 136.304 211.508 132.975 211.461C131.182 211.442 129.522 212.023 128.196 213.025C126.346 214.427 125.134 216.631 125.096 219.139C125.049 222.592 127.271 225.549 130.381 226.608C131.134 226.866 131.936 227.009 132.775 227.018C133.757 227.028 134.702 226.856 135.57 226.532C136.943 226.026 138.136 225.139 139.023 224.004C139.9 222.878 140.473 221.495 140.616 219.998C140.635 219.778 140.644 219.569 140.654 219.349C140.654 219.216 140.654 219.073 140.654 218.939L140.644 218.929ZM127.052 219.158C127.071 217.298 127.967 215.648 129.341 214.599C130.343 213.836 131.592 213.387 132.956 213.407C135.446 213.435 137.554 215.028 138.365 217.241C138.555 217.766 138.67 218.329 138.708 218.91C138.708 219.044 138.718 219.168 138.708 219.301C138.708 219.864 138.613 220.408 138.451 220.923C138.241 221.61 137.916 222.239 137.487 222.793C137.334 222.993 137.163 223.184 136.982 223.365C135.913 224.424 134.435 225.072 132.804 225.053C132.374 225.053 131.955 224.996 131.554 224.901C131.373 224.863 131.192 224.805 131.01 224.748C128.683 223.956 127.023 221.743 127.052 219.149V219.158Z",
  fill: "#E3F2FF"
});

var _ref35 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.74
}, /*#__PURE__*/React.createElement("path", {
  d: "M302.035 296.273H241.157C236.868 296.273 233.392 299.75 233.392 304.038V348.236C233.392 352.524 236.868 356 241.157 356H302.035C306.323 356 309.8 352.524 309.8 348.236V304.038C309.8 299.75 306.323 296.273 302.035 296.273Z",
  fill: "#AF42E7"
}));

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M273.212 302.385H300.484C303.109 302.385 305.232 304.508 305.232 307.133V344.046C305.232 346.672 303.109 348.795 300.484 348.795H273.212C270.586 348.795 268.464 346.672 268.464 344.046V307.133C268.464 304.508 270.586 302.385 273.212 302.385Z",
  fill: "#F6E8FE"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M244.163 302.385H258.128C259.737 302.385 261.044 303.692 261.044 305.301V306.094C261.044 307.703 259.737 308.999 258.14 308.999H244.174C242.565 308.999 241.269 307.692 241.269 306.094V305.301C241.269 303.692 242.576 302.385 244.185 302.385H244.163Z",
  fill: "#F6E8FE"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M244.163 314.741H258.129C259.738 314.741 261.034 316.049 261.034 317.646V318.439C261.034 320.048 259.726 321.344 258.129 321.344H244.163C242.555 321.344 241.259 320.037 241.259 318.439V317.646C241.259 316.037 242.566 314.741 244.163 314.741Z",
  fill: "#F6E8FE"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M385.435 235.065C389.613 225.712 385.418 214.743 376.065 210.565C366.712 206.387 355.743 210.582 351.565 219.935C347.387 229.288 351.582 240.257 360.935 244.435C370.288 248.613 381.257 244.418 385.435 235.065Z",
  fill: "#F44336"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M361.391 236.912C360.8 236.912 360.212 236.688 359.761 236.237C358.858 235.338 358.858 233.876 359.761 232.976L373.974 218.763C374.874 217.86 376.336 217.86 377.235 218.763C378.138 219.662 378.138 221.124 377.235 222.024L363.022 236.237C362.57 236.688 361.982 236.912 361.391 236.912Z",
  fill: "white"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M375.608 236.912C375.017 236.912 374.429 236.688 373.978 236.237L359.764 222.024C358.862 221.124 358.862 219.662 359.764 218.763C360.664 217.86 362.126 217.86 363.025 218.763L377.239 232.976C378.141 233.876 378.141 235.338 377.239 236.237C376.788 236.688 376.2 236.912 375.608 236.912Z",
  fill: "white"
});

var _ref42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_19919_10815",
  x1: 396.824,
  y1: 245.787,
  x2: 124.961,
  y2: 19.6466,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEAEA",
  stopOpacity: 0.44
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_19919_10815"
}, /*#__PURE__*/React.createElement("rect", {
  width: 327,
  height: 264,
  fill: "white",
  transform: "translate(61 92)"
})));

function SvgAideNoservices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 453,
    height: 404,
    viewBox: "0 0 453 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19919_10815)"
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.78
  }, _ref33), _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41), _ref42);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAideNoservices);
export default __webpack_public_path__ + "static/media/aide-noservices.9ec49d2d82755c332eafd5bdbf165ca2.svg";
export { ForwardRef as ReactComponent };